import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import _get from 'lodash/get';
import { Alert } from 'antd';

import { IValidationAlertProps } from './ValidationAlert.types';

const ValidationAlert = ({
  error,
  errorBodyKeys = ['message', 'error', 'key'],
  messages,
  marginBottom,
  type = 'error',
  defaultMessage,
  onShowAlert,
  onHideAlert,
  style,
  ...props
}: IValidationAlertProps) => {
  const { t } = useTranslation();

  const errorMessage = useMemo(() => {
    if (!error) {
      return;
    }

    const errorTypes =
      typeof error === 'string' ? [error] : errorBodyKeys.map(key => _get(error?.body, key)).filter(Boolean);

    let errorMessage: string;

    errorTypes.forEach(errorType => {
      const message = messages[errorType];

      if (message) {
        errorMessage = message;
      }
    });

    if (errorMessage) {
      return errorMessage;
    }

    if (defaultMessage) {
      return defaultMessage;
    }
  }, [defaultMessage, error, errorBodyKeys, messages]);

  useEffect(() => {
    if (!error) {
      return;
    }

    if (errorMessage) {
      onShowAlert && onShowAlert();
    } else {
      onHideAlert && onHideAlert();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error, errorMessage]);

  return (
    errorMessage && <Alert title={t(errorMessage)} type={type} showIcon style={{ marginBottom, ...style }} {...props} />
  );
};

export default ValidationAlert;
